import { CAYUSE_TYPES } from "globals/constants";

const SEARCHABLE_FIELD_TYPES = [
	CAYUSE_TYPES.FUNDING_PROGRAM,
	CAYUSE_TYPES.ORG_FINDER,
	CAYUSE_TYPES.PERSON_FINDER,
	CAYUSE_TYPES.UNIT_FINDER,
	CAYUSE_TYPES.CLASSIFICATION_CODES,
];

export const isSearchableField = field => {
	return SEARCHABLE_FIELD_TYPES.includes(field.cayuseType);
};
